<dx-data-grid
  [dataSource]="prestations"
  keyExpr="id"
  [height]="utils.scrollHeightContent(74)"
  width="100%"
  [hoverStateEnabled]="true"
  [allowColumnResizing]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  [showBorders]="true"
  #grid>
  <dxi-column dataField="libelle" caption="Offres alimentaires"
              [allowSearch]="true"
              [filterOperations]="['contains']"
              [allowSorting]="true"
              [allowFiltering]="true">
  </dxi-column>
  <dxi-column dataField="convive" caption="Prestations" cellTemplate="conviveCellTemplate" [allowSearch]="false"
              [allowFiltering]="false" [allowSorting]="false"></dxi-column>

  <div *dxTemplate="let cell of 'conviveCellTemplate'" class="custom-button-container-left align-top">
    <div class="prestation-list">
      <ng-container
        *ngFor="let contratMenuConvive of cell.row.data.contratMenuConvives;trackBy : utils.trackByFn">
        <div class="mg-r-10">
          <label>
            {{contratMenuConvive.libelle}}
          </label>
        </div>
      </ng-container>
    </div>
  </div>
</dx-data-grid>
